import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 mb-24 overflow-y-hidden" }
const _hoisted_2 = { class: "row w-full flex justify-between" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "mt-5 px-5 pb-5 bg-white w-full border-lightgrey relative pt-5 rounded" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mb-7" }
const _hoisted_9 = { class: "mb-7" }
const _hoisted_10 = { class: "mb-7" }
const _hoisted_11 = { class: "mb-7" }
const _hoisted_12 = { class: "mb-7" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "pt-1.5" }, "Label Definitions", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex", _ctx.labelDefinitions.length == 0 && _ctx.selectedTabObj.id != 20406 ? 'btndisabled pointer-events-none' : 'filterButton']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterOpen()))
        }, [
          (_ctx.labelDefinitions.length == 0 && _ctx.selectedTabObj.id != 20406)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[2] || (_cache[2] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Data organization is the practice of categorizing and classifying data to make it more usable. Similar to a file folder, where we keep important documents,you'll need to arrange your data in the most logical and orderly fashion,so you -- and anyone else who accesses it --can easily find what they're looking for.Data organization is the practice of categorizing and classifyingdata to make it more usable. Similar to a file folder, where we keep important documents ,you'll need to arrange your data in the most logical and orderly fashion. ", -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Tabs, {
          value: _ctx.selectedTabIndex,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
          scrollable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.id,
                    value: tab.id,
                    onClick: ($event: any) => (_ctx.toggleTabs(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanels, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, {
                    key: tab.id,
                    value: tab.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        (_ctx.selectedTabObj.id == 20406)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "font-semibold mt-3" }, _toDisplayString('Impact'), -1)),
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.overAllData,
                                  headersData: _ctx.overAllHeaders,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"])
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "font-semibold mt-3" }, _toDisplayString('Operations'), -1)),
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.operationsData,
                                  headersData: _ctx.opsHeaders,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"])
                              ]),
                              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "font-semibold mt-3" }, _toDisplayString('Strategic'), -1)),
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.businessData,
                                  headersData: _ctx.businessHeaders,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"])
                              ]),
                              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "font-semibold mt-3" }, _toDisplayString('Financial'), -1)),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.financialData,
                                  headersData: _ctx.financialHeaders,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"])
                              ]),
                              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font-semibold mt-3" }, _toDisplayString('Compliance'), -1)),
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_newTable, {
                                  tableRowData: _ctx.legalData,
                                  headersData: _ctx.LegalHeaders,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_newTable, {
                                tableRowData: _ctx.labelDefinitions,
                                headersData: _ctx.Headers,
                                loadData: _ctx.dataLoading
                              }, null, 8, ["tableRowData", "headersData", "loadData"])
                            ])),
                        (_ctx.toolTipActive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ]))
}